var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"home-image-hover"},[(_vm.image == '' || _vm.image == null)?_c('div'):_c('div',[_c('img',{attrs:{"src":_vm.image,"alt":"Image","id":"image"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }